import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import SlsOrdTrackingReportActions from '../../Stores/SlsOrdTrackingReport/Actions';

const { Panel } = Collapse;

class SlsOrdTrackingReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initSlsOrdTracking } = this.props;

    if (curSiteFlowId > 0) {
      initSlsOrdTracking();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initSlsOrdTracking } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initSlsOrdTracking();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'sales_order_tracking' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

SlsOrdTrackingReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initSlsOrdTracking: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

SlsOrdTrackingReportScreen.defaultProps = {
  intl: {},
  match: {},

  initSlsOrdTracking: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initSlsOrdTracking: () =>
    dispatch(SlsOrdTrackingReportActions.slsOrdTrackingReportInitSlsOrdTracking())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SlsOrdTrackingReportScreen));
